<template>
  <div>
    <v-layout>
      <v-flex xs12>
        <v-subheader class="pa-0 ma-0">{{ question.text }}</v-subheader>
        <small v-if="!isValid" class="d-block px-2 mb-2 red--text"
          >Don't forget to click save to update the details for each line</small
        >
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs3 v-for="(value, key) in answers[0]" :key="value" class="pa-1">
        <span class="font-weight-bold">{{ key }}</span>
      </v-flex>
      <v-flex xs2><v-spacer></v-spacer></v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs11>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
    <div v-for="(answer, index) in answers" :key="index">
      <v-layout>
        <v-flex xs3 v-for="(value, index) in answer" :key="index" class="pa-1">
          <span class="text--lighten-1">{{ value }}</span>
        </v-flex>
        <v-flex xs2 class="pr-1">
          <v-btn text icon @click="removeAnswer(index)"><v-icon>fa-times-circle</v-icon></v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs11>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>
    </div>
    <v-layout>
      <v-flex xs3 v-for="(question, index) in questions" :key="index">
        <v-text-field
          v-model="question.value"
          :placeholder="question.label"
          type="text"
          v-if="question.type === 'text'"
          :required="isNullOrEmpty(value) && question.required"
          class="mx-2"
          dense
        ></v-text-field>
        <v-text-field
          v-model="question.value"
          :placeholder="question.label"
          type="text"
          v-if="question.type === 'currency'"
          prefix="£"
          :required="isNullOrEmpty(value) && question.required"
          class="mx-2"
          dense
        ></v-text-field>
        <v-text-field
          v-model="question.value"
          :placeholder="question.label"
          type="number"
          v-if="question.type === 'number'"
          :required="isNullOrEmpty(value) && question.required"
          class="mx-2"
          dense
        ></v-text-field>
        <v-select
          :items="createSelectFromIds(question)"
          v-model="question.value"
          v-if="question.type === 'selectFromAnswer'"
          single-line
          hide-details
          dense
        ></v-select>
      </v-flex>
      <v-flex xs2>
        <v-btn @click="setSelectedText">save</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'input-json',
  props: ['value', 'customerId', 'question', 'AnswerSet'],
  data: () => ({
    answers: [],
    questions: []
  }),
  computed: {
    ...mapGetters([
      'GetAnswersForQuestion',
      'getAnswerById',
      'getAnswerByQuestionId',
      'getQuestionById',
      'getAnswerLabelById'
    ]),
    isValid() {
      return this.answers.length > 0;
    }
  },
  methods: {
    ...mapActions(['updateAnswerSet']),
    setSelectedText() {
      let answers = {};
      let invalid = false;
      _.forEach(this.questions, function(question) {
        if (question.value === '') {
          invalid = true;
        }
        answers[question.label] = question.value;
      });
      if (invalid === true) {
        return false;
      }
      this.answers.push(answers);
      this.$emit('changedText', JSON.stringify(this.answers), this.isValid);
      this.questions = JSON.parse(this.question.answers[0].label);
      this.updateAnswerSet({
        id: this.customerId,
        answerSet: this.AnswerSet,
        answerId: this.question.answers[0].id,
        answerText: JSON.stringify(this.answers),
        questionId: this.question.id,
        isCritical: this.question.is_critical
      });
    },
    removeAnswer(index) {
      this.answers.splice(index, 1);
      this.$emit('changedText', JSON.stringify(this.answers), this.isValid);
      this.updateAnswerSet({
        id: this.customerId,
        answerSet: this.AnswerSet,
        answerId: this.question.answers[0].id,
        answerText: JSON.stringify(this.answers),
        questionId: this.question.id,
        isCritical: this.question.is_critical
      });
    },
    createSelectFromIds: function(question) {
      let select = [];
      question.selectValues.forEach(option => {
        if (
          !_.isUndefined(this.getAnswerByQuestionId(option.text[0])) &&
          this.visible(this.getQuestionById(option.text[0]))
        ) {
          let selectText = '';
          let selectValue = '';
          option.text.forEach(text => {
            let answer = this.getAnswerByQuestionId(text);
            selectText = selectText + answer.answer_text + ' ';
          });
          option.value.forEach(text => {
            let answer = this.getAnswerByQuestionId(text);
            let answerValue =
              _.isUndefined(answer.answer_text) || _.isNull(answer.answer_text)
                ? this.getAnswerLabelById(answer.question_id, answer.answer_id)
                : answer.answer_text;
            selectValue = selectValue + answerValue + ' ';
          });
          select.push({ value: _.trim(selectValue), text: _.trim(selectText) });
        }
      });
      return select;
    },
    isNullOrEmpty(value) {
      return _.isNull(value) || value === '[]';
    }
  },
  mounted() {
    this.answers = _.isNull(this.value) ? [] : JSON.parse(this.value);
    this.questions = JSON.parse(this.question.answers[0].label);
  }
};
</script>

<style scoped></style>
